import type { Meta, StoryObj } from "@storybook/react";

import { Accordion, Text } from "@/ui/core";
import type { AccordionProps } from "@/ui/core";

const StoryMeta: Meta<AccordionProps> = {
  title: "Core/Accordion",
  component: Accordion,
  argTypes: {
    testID: { control: "text" },
    title: { control: "text" },
  },
  args: {
    testID: "accordion-test-id",
    title: "Accordion",
  },
};

type Story = StoryObj<AccordionProps>;

const Primary: Story = {
  ...StoryMeta,
  render: (args) => {
    return (
      <Accordion {...args}>
        <Text testID="accordion-content">
          Simple text content of the accordion which is hidden by default and
          would be shown when the accordion is expanded
        </Text>
      </Accordion>
    );
  },
};

export { Primary };
export default StoryMeta;
